import {useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsOverviewRoute} from '../../../routes/overview-route'

export const useAssigneesQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'assignees')
export const useReviewRequestsQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'review_requests')
export const useDevelopmentQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'development')
export const useLabelsQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'labels')
export const useParticipantsQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'participants')
